import { useState } from "react";
import { faqs } from "@/mocks/evidence";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqs[0]?.id ?? "");

  return (
    <section id="faq" className="w-full border-y border-background-200 bg-background-100/70 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 font-label text-xs text-primary-700">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-question-answer-line text-sm" />
              </span>
              常见问题
            </span>
            <h3 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              关于实锤照片的常见疑问
            </h3>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
              来源如何标注、聊天截图怎么看拼接、同框照和定位怎么互证，这里一次说清楚。
            </p>
            <div className="mt-6 flex items-center gap-3 rounded-lg border border-secondary-200 bg-secondary-50 px-4 py-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className="ri-shield-check-line text-lg" />
              </span>
              <p className="text-xs leading-6 text-secondary-900">
                遇到存疑画面，建议先在时间线里对照，再决定是否采信。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-8">
            {faqs.map((item) => {
              const open = openId === item.id;
              return (
                <div
                  key={item.id}
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? "" : item.id)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                    </span>
                  </button>
                  {open && (
                    <div className="px-5 pb-5">
                      <p className="border-t border-background-200 pt-4 text-sm leading-7 text-foreground-600">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}